import { Typography } from "@mui/material";
import type { Country } from "adl-gen/common";
import { countryCodeToCountryName } from "utils/conversion-utils";

export interface Address {
  streetName?: string;
  addressLine1: string;
  addressLine2: string;
  town: string;
  postCode: string;
  country: Country | null;
  state?: string | null;
}

export const AddressTypography = ({
  streetName,
  addressLine1,
  addressLine2,
  town,
  postCode,
  country,
  state,
}: Address) => {
  return (
    <>
      {streetName && <Typography>{streetName}</Typography>}
      <Typography>{addressLine1}</Typography>
      <Typography>
        {addressLine2 && `${addressLine2}, `}
        {town}
        {state && country === "US" && `, ${state}`}
      </Typography>
      <Typography>{postCode}</Typography>
      {country && (
        <Typography>{countryCodeToCountryName(country as Country)}</Typography>
      )}
    </>
  );
};
